import { render } from "./DbForm.vue?vue&type=template&id=7e0e6ea6"
import script from "./DbForm.vue?vue&type=script&lang=js"
export * from "./DbForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__